.animation-container {
    width: 400px;
    height: 300px;
}
